import TaxAgent from '@/pages/Finance/TaxAgent'
import Fee from '@/pages/Finance/Fee'
import Capital from '@/pages/Finance/Capital'
import Cash from '../pages/Finance/Cash'

export default [
    {
        path: '',
        component: TaxAgent,
        redirect: 'taxagent'
    },
    {
        path: 'taxagent',
        component: TaxAgent
    },
    {
        path: 'fee',
        component: Fee
    },
    {
        path: 'capital',
        component: Capital
    },
    {
        path: 'cash',
        component: Cash
    }
]
